export enum LocalStorageKeysEnum {
  LANG = 'lang',
  PRODUCT = 'product',
  SELECT_TAB_ID = 'select-tab-id',
}
